(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/search-results/result-item.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/search-results/result-item.js');
'use strict';

const {
  ListItemLink
} = svs.ui.ReactListGroup;
const {
  ReactBadge: Badge,
  ReactIcon
} = svs.ui;
const {
  Link
} = svs.app.ReactRouter;
const ResultItem = _ref => {
  let {
    receiver,
    onClick
  } = _ref;
  const onKeyDownHandler = event => {
    if (event.keyCode === svs.utils.keylistener.KEY_ENTER) {
      onClick(receiver, event);
    }
  };
  return React.createElement(ListItemLink, null, React.createElement(Link, {
    onKeyDown: onKeyDownHandler,
    to: "/"
  }, React.createElement("div", {
    className: "grid-row padding-1 result-item",
    onClick: event => onClick(receiver, event)
  }, React.createElement("div", {
    className: "col-xs-11"
  }, React.createElement("div", {
    className: "margin-bottom-1"
  }, React.createElement("p", {
    className: "longname"
  }, receiver.longname), React.createElement("div", {
    className: "subcategory"
  }, receiver.subcategory === '' ? React.createElement(Badge, {
    className: "grassroots-badge"
  }, "Huvudf\xF6rening") : React.createElement("p", null, receiver.subcategory))), React.createElement("p", {
    className: "normal"
  }, receiver.location.city)), React.createElement("div", {
    className: "col-xs-1"
  }, React.createElement(ReactIcon, {
    className: "margin-top-2",
    color: "fc-black",
    icon: "arrow-right"
  })))));
};
svs.grassroots.components.search_results.ResultItem = ResultItem;

 })(window);